import React from 'react';

const DOT = { joined: '#16a34a', loose: '#f97316' };

// Connection dots on every line end (green = joined, orange = loose) and,
// in Edit mode, draggable handles on every vertex.
export const EndpointLayer = ({ nodes, strokes, scale, editMode, onStartDrag }) => (
  <g data-testid="trace-endpoint-layer">
    {nodes.map((n, i) => {
      const loose = n.ends === 1 && n.kind !== 'stop_end';
      const colour = n.kind === 'stop_end' ? '#0ea5e9' : loose ? DOT.loose : DOT.joined;
      return (
        <g key={`n-${i}`} data-testid={`trace-node-${i}`} style={{ pointerEvents: 'auto' }}>
          <title>{n.label}{n.ends > 1 ? ` · ${n.ends} line ends` : ''}</title>
          <circle cx={n.x * scale} cy={n.y * scale} r={4} fill={colour} stroke="#fff" strokeWidth={1.5} />
        </g>
      );
    })}
    {editMode && strokes.map((s, si) => (s.type === 'point' || !Array.isArray(s.points) ? null : s.points.map((p, pi) => (
      <rect key={`h-${si}-${pi}`} data-testid={`trace-handle-${si}-${pi}`}
        x={p.x * scale - 6} y={p.y * scale - 6} width={12} height={12} rx={2}
        fill="rgba(255,255,255,0.85)" stroke="#1e293b" strokeWidth={1.5}
        style={{ cursor: 'move', pointerEvents: 'auto' }}
        onPointerDown={(e) => { e.stopPropagation(); e.preventDefault(); onStartDrag(si, pi); }}
        onClick={(e) => e.stopPropagation()} />
    ))))}
  </g>
);

export const ConnectionSummary = ({ summary }) => {
  const c = summary.counts;
  const items = [
    ['Mitre ext', c.mitre_external], ['Mitre int', c.mitre_internal], ['Stop ends', c.stop_end],
    ['Starters', c.starter], ['Laps', c.lap], ['Apex laps', c.apex], ['Valley joins', c.valley_join], ['Loose ends', c.loose],
  ].filter(([, v]) => v);
  return (
    <div className="flex flex-wrap gap-1 text-[10px]" data-testid="trace-connection-summary">
      {items.length === 0 && <span className="text-slate-400">No connections yet</span>}
      {items.map(([k, v]) => (
        <span key={k} className={`px-1.5 py-0.5 rounded-full ${k === 'Loose ends' ? 'bg-orange-100 text-orange-800' : 'bg-emerald-50 text-emerald-800'}`}>{k}: {v}</span>
      ))}
      {summary.outlets > 0 && (
        <span className={`px-1.5 py-0.5 rounded-full ${summary.outletsOnGutter === summary.outlets ? 'bg-emerald-50 text-emerald-800' : 'bg-orange-100 text-orange-800'}`}>
          Outlets on gutter: {summary.outletsOnGutter}/{summary.outlets}
        </span>
      )}
    </div>
  );
};
